// 当前 tab 的 session 供 UI 与 HTTP 共用；sessionStorage 只用于刷新后恢复。
import { AdminUserSchema, type AdminUser } from '@novelaide/shared-types/admin-auth'

// 保留既有 key，避免升级时丢 session；值已经是 Better Auth opaque token，不是 JWT。
const SESSION_TOKEN_KEY = 'nv-admin-jwt'
const ADMIN_KEY = 'nv-admin-user'

interface AdminSession {
  token: string | null
  admin: AdminUser | null
}

let currentSession: AdminSession | undefined

function session(): AdminSession {
  if (currentSession) return currentSession
  let token: string | null = null
  let admin: AdminUser | null = null
  try {
    token = window.sessionStorage.getItem(SESSION_TOKEN_KEY)
    const raw = window.sessionStorage.getItem(ADMIN_KEY)
    if (raw) {
      const parsed = AdminUserSchema.safeParse(JSON.parse(raw) as unknown)
      if (parsed.success) admin = parsed.data
    }
  } catch {
    // 不可用或损坏的恢复数据不授予登录态；当前 tab 登录仍可保存在内存。
  }
  currentSession = { token, admin }
  return currentSession
}

function removeStoredValue(key: string): boolean {
  try {
    window.sessionStorage.removeItem(key)
    return true
  } catch {
    return false
  }
}

export function loadToken(): string | null {
  return session().token
}

export function saveToken(token: string): void {
  session().token = token
  try {
    window.sessionStorage.setItem(SESSION_TOKEN_KEY, token)
  } catch {
    // 恢复副本不可用不影响当前 tab 的 session。
  }
}

export function clearToken(): void {
  session().token = null
  removeStoredValue(SESSION_TOKEN_KEY)
}

export function loadAdmin(): AdminUser | null {
  return session().admin
}

export function saveAdmin(admin: AdminUser): void {
  session().admin = admin
  try {
    window.sessionStorage.setItem(ADMIN_KEY, JSON.stringify(admin))
  } catch {
    // 展示投影与 token 共用当前 session，不依赖恢复副本写入成功。
  }
}

export function clearAdmin(): void {
  session().admin = null
  removeStoredValue(ADMIN_KEY)
}

// === 整体清理(logout / 401 兜底)===

export function clearSession(): void {
  currentSession = { token: null, admin: null }
  const tokenRemoved = removeStoredValue(SESSION_TOKEN_KEY)
  const adminRemoved = removeStoredValue(ADMIN_KEY)
  if (tokenRemoved && adminRemoved) currentSession = undefined
}
